/* LAVY · Shows the "$" amounts written in promo texts (announcement bar, cart bundle bar,
   cart carousel title, popup) in the customer's currency, using Shopify's active rate.
   Example: "SAVE $50" -> "SAVE £50" (UK) or "SAVE €47" (EU, if the rate is 0.94).
   To use it in another text, add data-nr-money to the element. */
(function () {
  var cur = window.Shopify && window.Shopify.currency;
  if (!cur || !cur.active) return;
  var code = cur.active;
  var rate = parseFloat(cur.rate) || 1;
  if (code === 'USD' && rate === 1) return;

  // Only texts written by hand in USD (settings). Amounts rendered by Liquid (money filter) are already local: never listed here.
  var SEL = '.announcement-bar__message, .nr-cd__bmsg, .nr-cd__bar-labels, .nr-upsell__heading, .nr-pop, [data-nr-money]';
  // A bare "$" only: "CA$", "US$", "A$" are already a currency symbol and are left alone.
  var RE = /(^|[^A-Za-z])\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(?:\.\d+)?)/g;
  var nf;
  try {
    nf = new Intl.NumberFormat('en', { style: 'currency', currency: code, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  } catch (e) {
    return;
  }
  function conv(m, pre, num) {
    var n = parseFloat(num.replace(/,/g, ''));
    if (isNaN(n)) return m;
    return pre + nf.format(Math.round(n * rate));
  }
  // Idempotent: the original USD text is kept on the node and every run converts from it,
  // so re-runs (MutationObserver) and currencies whose symbol contains "$" (CAD, AUD, MXN) never stack.
  function fromOrig(node) {
    if (node.__nrOrig === undefined) node.__nrOrig = node.nodeValue;
    return node.__nrOrig;
  }
  function fix(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentNode;
      if (parent && (parent.nodeName === 'SCRIPT' || parent.nodeName === 'STYLE')) continue;
      var orig = fromOrig(node);
      if (orig.indexOf('$') === -1) continue;
      var out = orig.replace(RE, conv);
      if (node.nodeValue !== out) node.nodeValue = out;
    }
    if (el.hasAttribute('aria-label')) {
      if (el.getAttribute('data-nr-orig-label') === null) el.setAttribute('data-nr-orig-label', el.getAttribute('aria-label'));
      var ol = el.getAttribute('data-nr-orig-label');
      if (ol.indexOf('$') > -1) {
        var al = ol.replace(RE, conv);
        if (el.getAttribute('aria-label') !== al) el.setAttribute('aria-label', al);
      }
    }
  }
  function run(root) {
    (root || document).querySelectorAll(SEL).forEach(fix);
    (root || document).querySelectorAll('.nr-cd__bar[aria-label]').forEach(fix);
  }
  function boot() {
    run();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 30);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
